<template>
    <div class="add-popup-component" :style="height">
        <div class="add-popup-container" ref="addPopupImg">
            <div class="global_popup_header">{{title}}<i @click="$store.commit('windowHandle')"></i></div>
            <div class="global_popup_body">
                <el-form :model="formData" :rules="rules" ref="formData" @submit.native.prevent label-position="top">

                    <el-form-item v-for="item in ruleProps" :key="item.prop" :label="item.label" :prop="item.prop" @keyup.enter.native="submitForm('formData')" class="itemName">
                        <el-input v-model="formData[item.prop]" :placeholder="item.placeholder"></el-input>
                    </el-form-item>
                    <div class="edit-opts">
                        <p class="item">{{$t('content.books.pic')}}</p>
                        <div class="edit-cover">
                            <img :src="imageUrl" alt="" ref="addDefaultImg">
                            <div class='edit-upload'>
                                <el-upload
                                        ref="uploadFiles"
                                        action=""
                                        class="edit-upload-btn"
                                        :show-file-list="false"
                                        :on-change="coverPreview"
                                        :http-request="httpRequest"
                                >
                                    <h4>{{$t('commonMsg.replace')}}</h4>
                                </el-upload>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div class="global_popup_footer">
                <button @click="submitForm('formData')">{{$t('commonMsg.confirm')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {uploadAliyun} from '@/utils/aliyun';

export default {
    props: {
        title: {
            type: String
        },
        ruleForm: {
            type: Object
        },

        ruleProps: {
            type: Array
        },

        rules: {
            type: Object
        }
    },
    computed: {
        formData() {
            this.data = Object.assign({}, this.ruleForm)
            return this.data
        }
    },
    data(){
        return {
            data: null,
            height: '',
            imageUrl: require('./cmb_book_cover.png'),
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs.formData.validate(async (valid) => {
                if (this.$refs.uploadFiles.uploadFiles.length) {
                    let imageUrl = await uploadAliyun(this.$refs.uploadFiles.uploadFiles)
                    this.data.image_url =  imageUrl;
                    this.$emit('addEvnImg', this.data)
                }else {
                    this.$emit('addEvnImg', this.data)
                }
            })
        },
        coverPreview(file) {
            let coverUrl = URL.createObjectURL(file.raw);
            this.imageUrl = coverUrl
        },
        httpRequest(params) {
        }
    },
    mounted() {
            this.height = `height: ${this.$refs.addPopupImg.clientHeight}px`
    },

}
</script>

<style lang="scss" scoped>
    .add-popup-component{
        @include globalPopup(450px);
        .add-popup-container{
            background:#fff;
            border-radius: 4px;
        }
        .edit-opts {
            display: flex;
            margin-bottom: 20px;
            > .el-input {
                flex: 1;
            }
            > .item {
                width: 100px;
            }
            > p {
                margin-right: 20px;
            }
            >p.items{
                margin-right: 0;
            }
            .edit-cover {
                position: relative;
                /*overflow: hidden;*/
                img {
                    width: 120px;
                    height: 166px;
                }
                .edit-upload {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    transition: all .2s;
                    &:hover {
                        transition: all .2s;
                        background: rgba($color: #000000, $alpha: .5);
                        .edit-upload-btn {
                            display: block;
                        }
                    }
                    .edit-upload-btn {
                        display: none;
                        cursor: pointer;
                        color: #fff;
                        font-weight: bold;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                    }
                }

            }
        }
    }
</style>


